import { useState } from 'react';
import { collectTractPolygons } from '../helpers/googleMap/collectTractPolygons';

export default function ActivePolygonsController() {
  const [polygons, setPolygons] = useState([]);
  
  const updatePolygons = (tractData) => {
    const activePolygons = collectTractPolygons(tractData);
    setPolygons(activePolygons);

    return activePolygons;
  };

  const clearPolygons = () => {
    setPolygons([]);
  }

  return { polygons, updatePolygons, clearPolygons }
}
